import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-909a6394"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "txt"
};
const _hoisted_3 = {
  key: 0,
  class: "protocal-content-title"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = /*#__PURE__*/_createTextVNode("建议与反馈");
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交");
import { mdToast } from "@/utils/tools";
import { getRulePublicityDetail, postHelpcenterQuestionDetails } from "@/api/index";
import { reactive, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import cont_match_reg from "@/utils/editor.js";
import { decodeEntities } from "@/utils/tools.js";
export default {
  setup(__props) {
    const state = reactive({
      id: '',
      info: {},
      content: '',
      feedbackType: 0,
      feedbackText: '',
      submitLoading: false
    });
    const isLucky = computed(() => window.location.href.includes('m.hi-mystery.com'));
    const route = useRoute();
    onMounted(() => {
      state.id = route.params.id;
      getDetail({
        id: state.id
      });
    });
    const getDetail = params => {
      state.id = params.id;
      getRulePublicityDetail({
        id: params.id
      }).then(res => {
        if (res.status == 0) {
          state.info = res.data;
          document.title = state.info.title;
          let cont = state.info.content;
          if (cont.indexOf('&gt;') > -1) {
            cont = decodeEntities(cont);
          }
          const processedCont = cont_match_reg(cont, process.env.VUE_APP_ENV, 800, 'project');
          state.content = processedCont ? processedCont.innerHTML : cont;
        }
      });
    };
    const back = () => {
      window.history.go(-1);
    };
    const handleSubmitFeedback = async () => {
      if (!state.feedbackText) return;
      if (state.submitLoading) return;
      state.submitLoading = true;
      try {
        const res = await postHelpcenterQuestionDetails({
          lid: state.id,
          cid: 99,
          content: (state.feedbackText || "").trim(),
          enviroment: window.navigator.userAgent
        });
        if (Number(res === null || res === void 0 ? void 0 : res.status) === 2000) {
          state.feedbackText = "";
          mdToast('留言已收到，1-3个工作日内给您答复');
          return;
        }
        mdToast((res === null || res === void 0 ? void 0 : res.message) || "提交失败，请稍后重试");
      } catch (error) {
        mdToast("提交失败，请稍后重试");
      } finally {
        state.submitLoading = false;
      }
    };
    return (_ctx, _cache) => {
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(isLucky) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "header",
        onClick: _withModifiers(back, ["stop"])
      }, [_createElementVNode("p", _hoisted_2, _toDisplayString(_unref(state).info.title), 1)], 8, _hoisted_1)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(['protocal-content', {
          'lucky': _unref(isLucky)
        }, 'protocal'])
      }, [!_unref(isLucky) ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(_unref(state).info.title), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "protocal-content-content",
        innerHTML: _unref(state).content
      }, null, 8, _hoisted_4), _createVNode(_component_van_radio_group, {
        class: "feedback-type",
        modelValue: _unref(state).feedbackType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(state).feedbackType = $event),
        direction: "horizontal"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_radio, {
          name: "1",
          "checked-color": "#00c4a1"
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _unref(state).feedbackType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_van_field, {
        class: "textarea",
        modelValue: _unref(state).feedbackText,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(state).feedbackText = $event),
        modelModifiers: {
          trim: true
        },
        rows: "4",
        autosize: "",
        type: "textarea",
        maxlength: "200",
        placeholder: "请输入您的建议与反馈",
        "show-word-limit": ""
      }, null, 8, ["modelValue"]), _createVNode(_component_van_button, {
        type: "primary",
        color: "#00c4a1",
        disabled: !_unref(state).feedbackText,
        block: "",
        class: "submit-btn",
        onClick: handleSubmitFeedback
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      }, 8, ["disabled"])])) : _createCommentVNode("", true)], 2)], 64);
    };
  }
};